(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/casino-react/max-favorites-dialog/assets/javascripts/max-favorites-dialog.js') >= 0) return;  svs.modules.push('/components/casino-react/max-favorites-dialog/assets/javascripts/max-favorites-dialog.js');
"use strict";


const showMaxFavoritesDialog = () => {
  const {
    maxFavoritesDialog: config
  } = svs.casino_react.shared.data;
  const dialogOptions = {
    branding: svs.ui.dialog.branding[config.dialogBranding],
    title: config.title,
    icon: 'favorites',
    area: svs.ui.dialog.area.POPUP,
    type: svs.ui.dialog.type.DEFAULT,
    product: 'Casino',
    message: [{
      type: svs.ui.dialog.message.TEXT,
      text: config.message
    }],
    actions: [{
      title: 'Okej',
      callback: () => {
        dialog.close();
      }
    }, {
      title: config.navAction.title,
      callback: () => {
        const url = svs.core.urlMapping.get(config.navAction.urlMappingKey);
        svs.utils.url.navigate(url);
        dialog.close();
      }
    }]
  };
  const dialog = new svs.ui.dialog.Confirm(dialogOptions);
  svs.ui.dialog.api.add(dialog);
};
setGlobal('svs.components.casino_react.maxFavoritesDialog', {
  showMaxFavoritesDialog,
  MAX_FAVORITES: svs.casino_react.shared.data.maxFavoritesDialog.maxFavorites
});

 })(window);